import axios from "axios";

let counter = 0;
const win: any = window;
const lang = win['lang']
let errorPage = win["errorPageURL"];

// const createTransactionID = () => {
//   let currentDateTime = new Date().toISOString().replace(/-|:|T/gi,'').replace('.','').slice(2).slice(0, -1);
//   return 'POR' + currentDateTime + '_' + Math.ceil(Math.random()*100000);
// }

let otpConfig = {
  api: {
    baseURL: '',
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: '',
      'x-transaction-id': '3124235347568',
      channel: "PORTAL",
      "cem-key": '',
    },
  },
}

export const otpApi = axios.create({...otpConfig.api});

otpApi.defaults.validateStatus = function () {
  return true;
};

otpApi.interceptors.request.use(
  async (conf: any) => {
    conf.baseURL = win['apigee_base_api_url'];
    conf.headers["cem-key"] = win['cem_key'];
    conf.headers.Authorization = `Bearer ${win["dapiToken"]}`;
    return conf;
  },
  (err) => {
    console.log("error in getting ", err);
  }
);

otpApi.interceptors.response.use(
  async (response: any) => {
    if (
      (response.data.code && response.data.code === "APIGEE-001") ||
      (response.data.code && response.data.code === "APIGEE-002")
    ) {
      counter++;
      const dapiToken = await reGenerateToken();
      const { config: oldRequest } = response;
      oldRequest.headers.Authorization = `Bearer ${dapiToken}`;
      if (counter < 2) return otpApi.request({ ...oldRequest });
    }

    return response;
  },
  async (error: any) => {
    if (!!errorPage) {
      document.location.href = errorPage;
    }
    return error;
  }
);

function reGenerateToken() {
  console.log("apigeeReGenerateTokenUrl :: Enter");
  console.log("apigeeReGenerateTokenUrl => " + win["base_portal_url"] + "" + '/mobilyTheme4/UtilityServlet?tk=dapi');

  return new Promise((resolve, reject) => {
    fetch(win["base_portal_url"] + "" + '/mobilyTheme4/UtilityServlet?tk=dapi', {
      method: "GET",
      headers: {
        "Content-type": "text/html; charset=UTF-8",
      },
    })
      .then((res) => res.text())
      .then((result) => {
        resolve(result);
      })
      .catch((err) => {
        reject(err);
      });
  });
}


const getOtp = (pNumberEncrypted: any, paramPhoneNumberEncrypted: any, currentDateEncrypted: any, moduleIdEncrypted: any, scanEncrypted:any, langEncrypted:any, otpLengthEncrypted:any, isNumericEncrypted:any,verificationEncrypted:any, otpStringEncrypted:any ) => {

  let data = {
    msisdn: pNumberEncrypted,
    san: scanEncrypted, //""
    moduleId: moduleIdEncrypted,
    language: langEncrypted,
    otpLength: otpLengthEncrypted, //"4"
    isNumeric: isNumericEncrypted, //"Y",
    verification:verificationEncrypted, //"Mobile",
    dynamicParams: [
      paramPhoneNumberEncrypted,
      currentDateEncrypted,
      otpStringEncrypted//"OTP"
    ]
  }
  return otpApi.post(`/utility/v1/otp/send`, data);
  // return otpApi.get('https://run.mocky.io/v3/4384ea08-9c22-4d43-98c8-610edd7bc615') //204 success
}

const submitOtp = (otp: any, hashCode: any) => {
  let data = {
    otp: otp,
    hashCode: hashCode,
  }
  return otpApi.put(`/utility/v1/otp/validate`, data);
  // return otpApi.get('https://run.mocky.io/v3/4384ea08-9c22-4d43-98c8-610edd7bc615') //204 success
  // return otpApi.get('https://run.mocky.io/v3/efba4a21-f8fe-467f-81d3-08ab5936b23f'); // not valid otp, 206 replace 260.
}

const resendOtp = (hashCode: any) => {
  let data = {
    hashCode: hashCode,
    language: lang.toUpperCase(),
    otpLength: '4',
    isNumeric: 'Y',
    verification: 'Mobile',
  }
  return otpApi.put(`/utility/v1/otp/resend`, data);
  // return otpApi.get('https://run.mocky.io/v3/4384ea08-9c22-4d43-98c8-610edd7bc615') //204 success
  // return otpApi.get('https://run.mocky.io/v3/efba4a21-f8fe-467f-81d3-08ab5936b23f'); // not valid otp, 206 replace 260.
}


export { getOtp, submitOtp, resendOtp };
